jQuery(document).ready(function ($) {
  "use strict";
  $(".infiniteslide").each(function () {
    var $this = $(this);
    var style = $this.data("style") || "left";
    var clone = parseInt($this.data("clone")) || 2;
    var speed = parseInt($this.data("speed")) || 100;
    if ($("body").hasClass("rtl")) {
      style = style === "left" ? "right" : "left";
    }
    $this.infiniteslide({
      speed: speed,
      direction: style,
      clone: clone,
    });
  });
})
